import { useTheme } from "@hooks";

export const ValidCheck = () => {
  const { theme } = useTheme();

  return (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" width="16" height="16" rx="8" fill={theme.validator.valid} />
      <path
        d="M7.25054 11.2558L13.2061 5.30019L12.32 4.41406L7.25054 9.48353L4.79824 7.03123L3.91211 7.91735L7.25054 11.2558Z"
        fill="#F4F1F2"
      />
    </svg>
  );
};
